// 模組05 資產管理 — mock 種子資料（機櫃 / 硬體）
// 機櫃「機櫃資訊」tab 欄位對準 Figma DCK-05_資產管理(115:28676):
//   機房名稱(roomId 帶入鎖定)、業務類別、資產類別、廠牌、型號(→帶出總U數)、機櫃編號(code)、
//   電源迴路、電壓、容量KVA、總U數(鎖定)、左/右電源數、PDU數(左右加總)、上架日期。
//   管理者不存在這裡 —— 它是「人 × 資產」的負責關係(ticket 31/35),見 db/workItems.js。

// 廠牌→型號→總U數 型錄:選型號自動帶出總U數(Figma cascade)
export const cabinetCatalog = {
  APC: [{ model: "AR3100", uTotal: 42 }, { model: "AR3200", uTotal: 45 }],
  Vertiv: [{ model: "VR3100", uTotal: 42 }, { model: "VR3350", uTotal: 48 }],
  Rittal: [{ model: "TS-IT-42U", uTotal: 42 }, { model: "TS-IT-47U", uTotal: 47 }],
};
// 資產類別／業務類別選項改走單一來源(ticket 06),不在這裡各自寫死 — 見 helpers/assetOptions.js

export const cabinets = [
  {
    id: 1,
    code: "R-A01",
    name: "A01 機櫃",
    roomId: 1,
    // 260804 機櫃表單新增的位置/資產欄位:樓層/區域(掛在機房的 floors[].areas[])、
    // 關鍵業務、資產編號/財產編號、購買金額(NT$)
    floorId: 1,
    areaId: 11,
    keyBiz: "不啟用",
    assetCode: "AST-2026-0001",
    propertyNo: "PRP-2026-0001",
    purchaseAmount: 200000,
    bizType: "一類業務",
    assetType: "機房相關",
    brand: "APC",
    model: "AR3100",
    powerCircuit: "PC-01",
    voltage: "220V",
    capacityKva: "5",
    uTotal: 42,
    // uUsed 不再是種子欄位(ticket 28):已用U 由 hardware 上架佔用推導(見 Assets/uSlots.js usedUOf)
    powerCount: 4,
    leftPower: 2,
    rightPower: 2,
    pduCount: 4,
    pduUsed: 3,
    mountDate: "2026-03-01",
    amortEndDate: "2028-01-05", // 結束攤提日(WF_v3 票 21 新欄位)
    docNo: "CAB-2026-0001",
    colorTag: "green",
    locked: false,
    status: "啟用中",
    approvalStatus: "approved",
    // 編輯頁的異動歷程(2128:26326)
    changeLog: [
      {
        at: "2026/07/08 14:32", by: "陳雅婷（EMP0113）", action: "新增",
        detail: "建立機櫃 R-A01（APC / AR3100・42U・PDU 4）",
        docNo: "RQ-20260708-004", result: "已核准（結案）",
      },
      {
        at: "2026/07/10 16:40", by: "張家豪（EMP0201）", action: "異動",
        detail: "管理者：陳雅婷（EMP0113） → 林承翰（EMP0145）",
        docNo: "RQ-20260710-006", result: "審核中（第 2 關）",
      },
    ],
  },
  {
    id: 2,
    code: "R-A02",
    name: "A02 機櫃",
    roomId: 1,
    floorId: 1,
    areaId: 12,
    keyBiz: "不啟用",
    assetCode: "AST-2026-0002",
    propertyNo: "",
    purchaseAmount: 180000,
    bizType: "一類業務",
    assetType: "機房相關",
    brand: "APC",
    model: "AR3200",
    powerCircuit: "PC-02",
    voltage: "220V",
    capacityKva: "5",
    uTotal: 45,
    powerCount: 4,
    leftPower: 2,
    rightPower: 2,
    pduCount: 4,
    pduUsed: 3,
    mountDate: "2026-03-05",
    amortEndDate: "2028-03-05",
    docNo: "CAB-2026-0002",
    colorTag: "gray",
    locked: false,
    status: "閒置",
    approvalStatus: "approved",
    changeLog: [],
  },
  {
    // WF_v3 票 21:維修中＋替代機(列表狀態欄「維修中｜替代機 APC / AR3100」)
    id: 3,
    code: "R-B01",
    name: "B01 機櫃",
    // 掛在桃園青埔(room 3):新莊(room 2)在 dcRoomsApi 測試裡是「無機櫃可刪」的樣本
    roomId: 3,
    floorId: 4,
    areaId: 41,
    keyBiz: "不啟用",
    assetCode: "AST-2026-0003",
    propertyNo: "",
    purchaseAmount: 200000,
    bizType: "二類業務",
    assetType: "機房相關",
    brand: "APC",
    model: "AR3100",
    powerCircuit: "PC-03",
    voltage: "220V",
    capacityKva: "5",
    uTotal: 42,
    powerCount: 4,
    leftPower: 2,
    rightPower: 2,
    pduCount: 4,
    pduUsed: 1,
    mountDate: "2026-04-10",
    amortEndDate: "2028-04-10",
    docNo: "CAB-2026-0003",
    colorTag: "gray",
    locked: false,
    status: "維修中",
    spareBrand: "APC",
    spareModel: "AR3100",
    approvalStatus: "approved",
    changeLog: [],
  },
];

// 硬體「硬體資訊」tab 欄位對準 Figma DCK-05 硬體(115:28676):
//   硬體編號(code)/名稱、廠牌/型號(→帶出 uSize)、位置(機櫃 cabinetId + U 位置,防呆)、
//   IP、EOL、EOS、維修/替代機(isSpare)、狀態(運行中/維修中/待汰換)。管理者見 db/workItems.js。
// 風險快速篩選(EOL/EOS 6個月內、維修中)以 eol/eos 日期與 status 前端計算。

// 廠牌→型號→佔用U數 型錄(mock;正式版由後端/爬蟲提供)
export const hardwareCatalog = {
  Dell: [{ model: "PowerEdge R750", uSize: 2 }, { model: "PowerEdge R650", uSize: 1 }],
  HPE: [{ model: "ProLiant DL380", uSize: 2 }, { model: "ProLiant DL360", uSize: 1 }],
  Lenovo: [{ model: "ThinkSystem SR650", uSize: 2 }],
};

// assetType(五選一:機房相關/網路相關/系統相關/軟體相關/其他)供智慧看板 EOS/EOL 分類統計。
// bizType(一類業務/二類業務/三類業務,ticket 06)。
export const hardware = [
  {
    id: 1, code: "SRV-A01-001", name: "核心服務主機", assetType: "系統相關", bizType: "一類業務",
    cabinetId: 1, uPosition: 10, uSize: 2, ip: "10.10.32.15",
    parentIp: "10.10.32.1", subnetMask: "255.255.255.0", gateway: "10.10.32.254",
    dns: "168.95.1.1", mac: "00:1A:2B:3C:4D:01", iface: "Eth0",
    secondaryIps: ["10.10.32.115", "192.168.0.15"],
    brand: "Dell", model: "PowerEdge R750", serialNo: "SN-DELL-0001",
    purchaseDate: "2023-12-20", mountDate: "2024-01-15", // 票 39:實測每筆都有值,種子照補(原本全空,編輯舊資料會被必填擋下)
    // 契約是多值 `operating_systems[]`／`application_systems[]`(前端仍讀單數欄位,見 hardwareContract 的 ⚠️)。
    // 種子至少要有一台帶值,否則那兩個陣列永遠是空的、形狀從沒被守到(票 39)。
    os: "Windows Server 2019", appSystems: "核心服務系統、報表系統",
    // 韌體版本是 CVE/KEV 的比對鍵;種子至少一台帶值,詳情頁才測得到「有值」的樣子
    firmwareVersion: "iDRAC9 7.00.00",
    // 韌體／作業系統名稱＋版本(人工維護,9/24 SIT 新欄位);種子至少一台帶值,詳情頁才測得到有值的樣子
    firmwareOsName: "iDRAC9",
    firmwareOsVersion: "iDRAC9 7.00.00.00",
    // 韌體 CPE 畫面沒有欄位,種一個值才測得到「編輯存檔不會把它洗掉」
    firmwareCpe: "cpe:2.3:o:dell:idrac9_firmware:7.00.00.00:*:*:*:*:*:*:*",
    eol: "2026-11-30", eos: "2027-10-31", endOfSale: "2025-04-30", starred: true, // EOL 6 個月內
    // CVE/KEV 等級(v2 列表新增的兩欄,2128:24810;mock 先種在硬體上,正式版由弱點爬蟲回寫)
    cveLevel: "嚴重", kevLevel: "高",
    // ⚠️ 契約外過渡值:2026-09-07 smoke 的 GetById/8 這兩欄是 **null**(後端缺陷另行回報)。
    // 種子給值只為了讓詳情頁的日期格有東西可驗;真後端接上時會是「—」。
    cveDate: "2024-04-24", kevDate: "2023-10-16",
    // 命中明細(票 uat-round3/01):**後端 DTO 形狀**,抄 2026-09-07 testenv smoke
    // (`DcHardware/GetById/8.vulnerability_hits`,46 筆裡挑代表性的四筆:
    // 兩筆 KEV、一筆非 KEV、一筆 severity「無」)。GetById 投影原樣吐出。
    vulnerabilityHits: [
      { cve_id: "CVE-2023-20198", severity: "嚴重", cvss_base_score: 10.0, category: "軟體(IOS XE)", is_kev: true,
        kev_date_added_utc: "2023-10-16T00:00:00", published_on_utc: "2023-10-16T23:00:00", is_platform_level: true,
        description: "Cisco IOS XE Software Web Management Interface Privilege Escalation Vulnerability",
        reference_url: "https://sec.cloudapps.cisco.com/security/center/content/CiscoSecurityAdvisory/cisco-sa-iosxe-webui-privesc-j22SaA4z" },
      { cve_id: "CVE-2017-3881", severity: "嚴重", cvss_base_score: 9.8, category: "軟體(IOS XE)", is_kev: true,
        kev_date_added_utc: "2022-03-25T00:00:00", published_on_utc: "2017-03-17T22:59:00.64", is_platform_level: true,
        description: "Cisco IOS and IOS XE Remote Code Execution Vulnerability",
        reference_url: "https://nvd.nist.gov/vuln/detail/CVE-2017-3881" },
      { cve_id: "CVE-2024-20353", severity: "高", cvss_base_score: 8.6, category: "軟體(IOS XE)", is_kev: false,
        kev_date_added_utc: null, published_on_utc: "2024-04-24T00:00:00", is_platform_level: false,
        description: "Cisco ASA and FTD Web Services Denial of Service Vulnerability",
        reference_url: "https://nvd.nist.gov/vuln/detail/CVE-2024-20353" },
      // 實測 46 筆 is_kev 全為 true,含 severity「無」的;這筆守「是 KEV 但沒有等級」的畫面
      { cve_id: "CVE-2021-1234", severity: "無", cvss_base_score: null, category: "韌體", is_kev: true,
        kev_date_added_utc: "2021-11-03T00:00:00", published_on_utc: "2021-02-03T00:00:00", is_platform_level: false,
        description: "Informational advisory (no CVSS assigned)",
        reference_url: "" },
    ],
    isSpare: false, status: "運行中",
    amortEndDate: "2028-01-15", // 結束攤提日(WF_v3 票 21 新欄位)
    docNo: "HW-2026-0001", approvalStatus: "approved",
    lifecycle: "commissioned",
  },
  {
    id: 2, code: "SRV-A01-002", name: "資料庫主機", assetType: "網路相關", bizType: "一類業務",
    cabinetId: 1, uPosition: 12, uSize: 2, ip: "10.10.32.16",
    parentIp: "10.10.32.1", subnetMask: "255.255.255.0", gateway: "10.10.32.254",
    dns: "168.95.1.1", mac: "00:1A:2B:3C:4D:02", iface: "Eth0",
    secondaryIps: [],
    brand: "HPE", model: "ProLiant DL380", serialNo: "SN-HPE-0001",
    purchaseDate: "2024-02-08", mountDate: "2024-03-01",
    eol: "2028-03-31", eos: "2026-12-31", endOfSale: "2025-06-30", starred: true, // EOS 6 個月內
    cveLevel: "中", kevLevel: "低",
    isSpare: false, status: "維修中", spareCode: "SRV-B02-001", // 維修期間的替代機(260804:同格帶出)
    amortEndDate: "2028-02-15", // 結束攤提日(WF_v3 票 21 新欄位)
    docNo: "HW-2026-0002", approvalStatus: "pending",
    lifecycle: "commissioned",
  },
  {
    id: 3, code: "SRV-B02-001", name: "備援替代機", assetType: "機房相關", bizType: "二類業務",
    cabinetId: 2, uPosition: 5, uSize: 1, ip: "10.10.33.20",
    parentIp: "", subnetMask: "255.255.255.0", gateway: "10.10.33.254",
    dns: "", mac: "00:1A:2B:3C:4D:03", iface: "ETH1",
    secondaryIps: [],
    brand: "Lenovo", model: "ThinkSystem SR650", serialNo: "SN-LEN-0001",
    purchaseDate: "2024-05-30", mountDate: "2024-06-18",
    eol: "2029-06-30", eos: "2030-06-30", endOfSale: "2027-01-31", starred: false, isSpare: true, status: "運行中", // 替代機
    amortEndDate: "2028-03-15", // 結束攤提日(WF_v3 票 21 新欄位)
    docNo: "HW-2026-0003", approvalStatus: "approved",
    lifecycle: "commissioned",
  },
  {
    id: 4, code: "SRV-A01-004", name: "應用伺服器", assetType: "系統相關", bizType: "一類業務",
    cabinetId: 1, uPosition: 14, uSize: 1, ip: "10.10.32.18",
    parentIp: "", subnetMask: "255.255.255.0", gateway: "10.10.32.254",
    dns: "", mac: "", iface: "",
    secondaryIps: [],
    brand: "Dell", model: "PowerEdge R650", serialNo: "SN-DELL-0004",
    purchaseDate: "2024-08-12", mountDate: "2024-09-02",
    eol: "2026-12-31", eos: "2028-06-30", endOfSale: "2025-04-30", starred: true, // EOL 6 個月內
    isSpare: false, status: "運行中",
    amortEndDate: "2028-04-15", // 結束攤提日(WF_v3 票 21 新欄位)
    docNo: "HW-2026-0004", approvalStatus: "approved",
    lifecycle: "commissioned",
  },
  {
    id: 5, code: "SRV-A02-001", name: "檔案伺服器", assetType: "機房相關", bizType: "二類業務",
    cabinetId: 2, uPosition: 8, uSize: 1, ip: "10.10.33.11",
    parentIp: "10.10.33.1", subnetMask: "255.255.255.0", gateway: "10.10.33.254",
    dns: "8.8.8.8", mac: "00:1A:2B:3C:4D:05", iface: "Eth0",
    secondaryIps: ["10.10.33.111"],
    brand: "HPE", model: "ProLiant DL360", serialNo: "SN-HPE-0005",
    purchaseDate: "2025-01-09", mountDate: "2025-02-03",
    eol: "2027-01-10", eos: "2026-11-30", endOfSale: "2025-09-30", starred: true, // EOL + EOS 皆 6 個月內
    isSpare: false, status: "運行中",
    amortEndDate: "2028-05-15", // 結束攤提日(WF_v3 票 21 新欄位)
    docNo: "HW-2026-0005", approvalStatus: "approved",
    lifecycle: "commissioned",
  },
  {
    id: 6, code: "SRV-B02-002", name: "防火牆主機", assetType: "網路相關", bizType: "三類業務",
    cabinetId: 2, uPosition: 10, uSize: 1, ip: "10.10.33.30",
    parentIp: "", subnetMask: "255.255.255.0", gateway: "10.10.33.254",
    dns: "", mac: "", iface: "",
    secondaryIps: [],
    brand: "Lenovo", model: "ThinkSystem SR650", serialNo: "SN-LEN-0006",
    purchaseDate: "2025-03-25", mountDate: "2025-04-14",
    eol: "2028-09-30", eos: "2026-10-31", endOfSale: "2025-03-31", starred: false, // EOS 6 個月內
    isSpare: false, status: "維修中",
    amortEndDate: "2028-06-15", // 結束攤提日(WF_v3 票 21 新欄位)
    docNo: "HW-2026-0006", approvalStatus: "approved",
    lifecycle: "commissioned",
  },
  {
    // 兩段式新增的中間態樣本(ticket 01):新增單已三關通過,U 位保留給它,
    // 但機器還沒實體進機房 —— 位置照流程圖的範例 R-A01 U16–U17。
    // ticket 03／05 靠這一筆才能不等 ticket 02 就獨立驗收。
    id: 7, code: "SRV-A01-007", name: "待上架應用主機", assetType: "系統相關", bizType: "一類業務",
    cabinetId: 1, uPosition: 16, uSize: 2, ip: "",
    brand: "Dell", model: "PowerEdge R760", serialNo: "SN-DELL-0007",
    purchaseDate: "2026-08-20", mountDate: "2026-09-10",
    eol: "2031-06-30", eos: "2032-06-30", endOfSale: "2029-12-31", starred: false,
    isSpare: false, status: "閒置",
    amortEndDate: "2028-07-15", // 結束攤提日(WF_v3 票 21 新欄位)
    docNo: "HW-2026-0007", approvalStatus: "approved",
    lifecycle: "reserved",
  },
];
